import { Text, View } from 'react-native';

import Receipt from '../../../elements/Receipt';
import { useTranslation } from '../../../i18n';
import { ReceiptType } from '../../../types/Common';
import { getIsTW } from '../../../utils/countryInfo';
import styles from './DeliverySection.style';
import type { InvoiceDataProps } from './types';

interface Props {
  invoiceData: InvoiceDataProps;
}

export default function ReceiptDataField({ invoiceData }: Props) {
  const { t } = useTranslation();

  const showReceiptCard =
    invoiceData.type === ReceiptType.TRIPLICATE || !!invoiceData.id;

  if (!getIsTW()) {
    return null;
  }

  return (
    <>
      <View testID="receipt-field" style={styles.dataField}>
        <Text style={styles.dataKeyText}>{t('receipt-type-with-symbol')}</Text>
        <Text style={[styles.dataValueLayout, styles.dataValueText]}>
          {invoiceData.invoice_text}
        </Text>
      </View>
      {showReceiptCard && (
        <Receipt
          testID="receiptCard"
          invoiceData={invoiceData}
          wrapperStyle={styles.receiptStyle}
        />
      )}
    </>
  );
}
